import React from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';

import {
  Media,
  ConditionalWrap,
  Box,
  VerticalSpacing,
} from '../../components/Boneyard';

import { useTranslations } from '../../graphql/components/TranslationsProvider';
import PageHeading from '../../components/PageHeading';

const propTypes = {
  theme: PropTypes.object.isRequired,
  automationHook: PropTypes.string.isRequired,
};

const FlightsPageHeader = ({ automationHook, theme }) => {
  const {
    flightsPage: { flightsPageHeading },
  } = useTranslations();

  return (
    <Media>
      {mq => (
        <ConditionalWrap
          condition={mq.lt('md')}
          wrap={children => (
            <>
              <Box
                w="100%"
                h="auto"
                bb={
                  '2px solid ' + theme.colors.travelers.borderBelowPageHeading
                }
              >
                {children}
              </Box>
              <VerticalSpacing size={2} />
            </>
          )}
        >
          <PageHeading
            title={flightsPageHeading}
            automationHook={automationHook}
          />
          {mq.gte('md') && <VerticalSpacing size={4} />}
        </ConditionalWrap>
      )}
    </Media>
  );
};

FlightsPageHeader.propTypes = propTypes;
FlightsPageHeader.displayName = 'FlightsPageHeader';

export default withTheme(FlightsPageHeader);
